function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SettingsTemplate = require('./settings.template');
var _require = require('../listing-approval'),
  isAutoSubmitListings = _require.isAutoSubmitListings,
  setAutoSubmitListings = _require.setAutoSubmitListings;
var SettingsOverlay = /*#__PURE__*/function () {
  function SettingsOverlay(app, mod) {
    _classCallCheck(this, SettingsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(SettingsOverlay, [{
    key: "isProfileLinked",
    value: function isProfileLinked() {
      var _this$mod$returnStore, _this$mod, _this$mod$returnProfi, _this$mod2;
      var url = String(((_this$mod$returnStore = (_this$mod = this.mod).returnStorefrontUrl) === null || _this$mod$returnStore === void 0 ? void 0 : _this$mod$returnStore.call(_this$mod, this.mod.publicKey)) || '').trim();
      if (!url) {
        return false;
      }
      return ((_this$mod$returnProfi = (_this$mod2 = this.mod).returnProfileStoreUrl) === null || _this$mod$returnProfi === void 0 ? void 0 : _this$mod$returnProfi.call(_this$mod2)) === url;
    }
  }, {
    key: "render",
    value: function render() {
      this.overlay.show(SettingsTemplate({
        profileLinkChecked: this.isProfileLinked(),
        autoSubmitListings: isAutoSubmitListings(this.app)
      }));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var toggle = document.querySelector('.store-settings [data-action="toggle-profile-link"]');
      toggle === null || toggle === void 0 || toggle.addEventListener('change', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$returnStore2, _this$mod3;
        var url, _this$mod$updateProfi, _this$mod4, _this$mod$updateProfi2, _this$mod5, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              url = ((_this$mod$returnStore2 = (_this$mod3 = _this.mod).returnStorefrontUrl) === null || _this$mod$returnStore2 === void 0 ? void 0 : _this$mod$returnStore2.call(_this$mod3, _this.mod.publicKey)) || '';
              _context.p = 1;
              if (!toggle.checked) {
                _context.n = 4;
                break;
              }
              if (url) {
                _context.n = 2;
                break;
              }
              toggle.checked = false;
              return _context.a(2);
            case 2:
              _context.n = 3;
              return (_this$mod$updateProfi = (_this$mod4 = _this.mod).updateProfile) === null || _this$mod$updateProfi === void 0 ? void 0 : _this$mod$updateProfi.call(_this$mod4, url);
            case 3:
              _this.app.connection.emit('store-profile-link-updated');
              _context.n = 5;
              break;
            case 4:
              _context.n = 5;
              return (_this$mod$updateProfi2 = (_this$mod5 = _this.mod).updateProfile) === null || _this$mod$updateProfi2 === void 0 ? void 0 : _this$mod$updateProfi2.call(_this$mod5, '');
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.warn('Store: profile link toggle failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
              toggle.checked = !toggle.checked;
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[1, 6]]);
      })));
      var autoSubmit = document.querySelector('.store-settings [data-action="toggle-auto-submit"]');
      autoSubmit === null || autoSubmit === void 0 || autoSubmit.addEventListener('change', function () {
        setAutoSubmitListings(_this.app, autoSubmit.checked);
      });
    }
  }]);
}();
module.exports = SettingsOverlay;